import { Link } from "react-router";
import { Nett } from "../footer/Nett";
import { handleOpenChat } from "utils/analytics";

export default function Footer() {
  return (
    <>
      <div className="w-full px-5 lg:px-10 py-5 bg-gray-50 border border-gray-100 bg-top">
        <footer className="flex justify-around flex-wrap max-w-screen-xl mx-auto">
          <div className="w-80 p-5">
            <p className="mb-2">Endereço</p>
            <p className="font-light">ROD AL 101 Norte </p>
            <p className="font-light">Barra Grande</p>
            <p className="font-light">Maragogi - Alagoas</p>
          </div>
          <div className="w-80 p-5 flex flex-col">
            <p className="mb-2">Atrações</p>
            <Link to="/piscinas-naturais" className="font-light">
              Piscinas Naturais
            </Link>
            <Link to="/passeio-de-orla" className="font-light">
              Passeio de Orla
            </Link>
            <Link to="/buggy-maragogi-norte" className="font-light">
              Buggy Maragogi Norte
            </Link>
            <Link to="/buggy-maragogi-sul" className="font-light">
              Buggy Maragogi Sul
            </Link>
            <Link to="/buggy-sao-miguel" className="font-light">
              Buggy São Miguel
            </Link>
          </div>
          <div className="w-80 p-5">
            <p className="mb-2">Fale conosco</p>
            <p className="font-light">reservas@barratour.com.br</p>
            <p className="font-light">wa.me/5582991194936</p>
            <p className="font-light">+55 (82)  99119-4936</p>
          </div>
          <div className="w-80 p-5">
              <p className="mb-2">Segue a gente</p>
              <div className="flex">
                <a href="https://www.instagram.com/maragogi_barratour" target="_blank" rel="noopener">
                  <img className="h-8 mr-8" src="/insta.png" alt="BarraTour" />
                </a>
                <button type="button" onClick={handleOpenChat}>
                  <img className="h-8" src="/wpp.png" alt="BarraTour" />
                </button>
              </div>
          </div>
        </footer>
      </div>
      <Nett />
    </>
  )
}